// extracted by mini-css-extract-plugin
export default {"l_SplitPagesContainer_main":"SplitPagesContainer_l_SplitPagesContainer_main__KthSi"};